var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagmaLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 32,
    viewBox: "0 0 251 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9817 2.10882C16.8748 0.56616 18.909 0.165303 20.4966 0.975685C26.2144 3.89422 33.0091 3.89422 38.7269 0.975686C40.3145 0.165304 42.3487 0.566159 43.2418 2.10882L58.0133 27.6254C58.9968 29.3244 57.1868 31.2702 55.4212 30.4121L52.9619 29.2168C48.4898 27.0431 43.2673 27.0431 38.7952 29.2168C32.9972 32.0349 26.2262 32.0349 20.4282 29.2168C15.9561 27.0431 10.7336 27.0431 6.26152 29.2168L3.80232 30.412C2.03674 31.2702 0.226746 29.3243 1.21025 27.6254L15.9817 2.10882Z",
    fill: "url(#paint0_linear_3420_5435)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3157 1.33007L20.4963 0.976373L20.3157 1.33007C18.8783 0.596383 17.0929 0.983553 16.3261 2.30815L1.5546 27.8247C0.767742 29.1839 2.21582 30.7408 3.62839 30.0542L6.08759 28.8589C10.6695 26.6319 16.0202 26.6319 20.6021 28.8589C26.2904 31.6237 32.9331 31.6237 38.6213 28.8589C43.2032 26.6319 48.5539 26.6319 53.1358 28.8589L55.5952 30.0542C57.0077 30.7408 58.4558 29.184 57.6689 27.8248L42.8974 2.30815C42.1306 0.983553 40.3452 0.596384 38.9078 1.33007C33.0764 4.3066 26.1471 4.3066 20.3157 1.33007Z",
    stroke: "url(#paint1_linear_3420_5435)",
    strokeOpacity: 0.2,
    strokeWidth: 0.795755
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0653 15.3238C32.8943 7.82477 34.1326 5.20519 38.9212 1.26754C40.2981 0.135409 42.3487 0.566884 43.2418 2.10954L58.0133 27.6262C58.9968 29.3251 57.1868 31.271 55.4212 30.4128L52.9619 29.2175C48.4898 27.0439 43.2673 27.0439 38.7952 29.2175C32.9972 32.0356 26.2262 32.0356 20.4282 29.2175C15.9561 27.0439 10.7336 27.0439 6.26152 29.2175L3.80232 30.4128C2.03674 31.2709 0.226746 29.325 1.21025 27.6261L8.89795 14.3462C8.89795 14.3462 24.6136 24.0425 29.0653 15.3238Z",
    fill: "url(#paint2_linear_3420_5435)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1739 1.57486C34.6131 5.32518 33.3345 7.83135 29.7915 14.776C29.6703 15.0136 29.5464 15.2565 29.4197 15.5047C28.2387 17.8177 26.2989 18.9099 24.0955 19.2426C21.9125 19.5723 19.4654 19.1601 17.1988 18.4859C14.926 17.8098 12.7998 16.8596 11.2449 16.0808C10.4665 15.6909 9.82929 15.343 9.38597 15.0921C9.25296 15.0168 9.13737 14.9503 9.04062 14.8939L1.55459 27.8255C0.767742 29.1847 2.21582 30.7415 3.62839 30.0549L6.08759 28.8596C10.6695 26.6326 16.0202 26.6326 20.6021 28.8596C26.2904 31.6244 32.9331 31.6244 38.6213 28.8596C43.2032 26.6326 48.5539 26.6326 53.1358 28.8596L55.5952 30.055C57.0077 30.7415 58.4558 29.1847 57.6689 27.8255L42.8974 2.30888C42.1198 0.965641 40.3495 0.608193 39.1739 1.57486Z",
    stroke: "url(#paint3_linear_3420_5435)",
    strokeOpacity: 0.1,
    strokeWidth: 0.795755
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.329 25.03L123.442 11.1311L111.63 25.03H106.144V24.4396L120.796 7.06299H126.192L140.859 24.4396V25.03H135.329Z",
    fill: "#F6F6F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.624 25.03L232.737 11.1311L220.924 25.03H215.439V24.4396L230.091 7.06299H235.487L250.153 24.4396V25.03H244.624Z",
    fill: "#F6F6F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.251 25.03V7.06299H78.5587L90.1498 14.8659L101.756 7.06299H108.749V7.65249L101.756 15.9423L101.756 12.3641L90.7264 19.7939H89.588L78.4256 12.1707V25.03H73.251Z",
    fill: "#F6F6F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.545 25.03V7.06299H187.852L199.443 14.8659L211.049 7.06299H218.042V7.65249L211.049 15.9423V12.3641L200.02 19.7939H198.882L187.719 12.1707V25.03H182.545Z",
    fill: "#F6F6F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.622 7.06299V11.1054H152.997C151.534 11.1054 151.312 11.2979 151.312 12.5686V19.5244C151.312 20.795 151.534 20.9876 152.997 20.9876H168.447V17.9714H159.887V13.9419H173.622V25.03H151.815C148.133 25.03 146.137 23.2973 146.137 20.102V11.991C146.137 8.79565 148.133 7.06299 151.815 7.06299H173.622Z",
    fill: "#F6F6F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3420_5435",
    x1: 26.7949,
    y1: 0.566406,
    x2: 29.7789,
    y2: 16.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#940000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3420_5435",
    x1: 38.7312,
    y1: 5.04251,
    x2: 9.88584,
    y2: 12.5059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564103,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3420_5435",
    x1: 58.291,
    y1: 0.629395,
    x2: 58.291,
    y2: 31.3311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3420_5435",
    x1: 58.1278,
    y1: 27.4229,
    x2: 2.92211,
    y2: 25.9308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279686,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511557,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagmaLogoText);
export default __webpack_public_path__ + "static/media/magmaLogo-text.146de3f8211d9dadbc07d091bc8a1822.svg";
export { ForwardRef as ReactComponent };